'use client'

import { DropdownItem, DropdownLabel } from '@algoacademy/design-system/web/actions/Dropdown'
import { authClient } from '@/app/_auth/auth-client'

const handleLogout = () => {
  void authClient.signOut({
    fetchOptions: {
      onSuccess: () => {
        window.location.href = '/baza'
      }
    }
  })
}

export function LogoutButton() {
  return (
    <DropdownItem destructive onClick={handleLogout}>
      <DropdownLabel>Wyloguj się</DropdownLabel>
    </DropdownItem>
  )
}
